import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { PharmacyDetails } from 'src/app/core/models/patient/pharmacyDetails';
import { UserService } from 'src/app/core/services/v2/user.service';

import {
  PatientContactPreferences,
} from '../../core/models/patient/contactPreferences';
import { PastHealthHistory } from '../../core/models/patient/PastHealthHostoryQuestions';
import { Patient } from '../../core/models/patient/patient';
import {
  PatientAdvancedDirective,
} from '../../core/models/patient/patientAdvancedDirective';
import { PatientChildren } from '../../core/models/patient/patientChildren';
import {
  PatientEmergencyContactInfo,
} from '../../core/models/patient/patientEmergencyContactInfo';
import { PatientHealthHistory } from '../../core/models/patient/PatientHealthHistory';
import { patientHealthType } from '../../core/models/patient/patientHealthType';
import { PatientInsuranceDetail } from '../../core/models/patient/patientInsuranceDetail';
import { PatientMedication } from '../../core/models/patient/patientMedication';
import { PatientService } from '../../core/services/v2/patient.service';
import { Practitioner } from '../../physician/profile/models/practitioner';
import { EventEmitterService } from 'src/app/core/services/v2/event-emitter.service';
import { ChangeDetectorRef } from "@angular/core";

import {
  WindowLoaderService,
} from '../../shared/components/window-loader/window-loader.service';
import {
  PatientPhotoEditComponent,
} from './profile-edit/patient-photo-edit/patient-photo-edit.component';
import {
  SidebarPatientEditComponent,
} from './profile-edit/sidebar-patient-edit/sidebar-patient-edit.component';
import {
  ProfileEmergencyContactInfoComponent,
} from './profile/profile-emergency-contact-info/profile-emergency-contact-info.component';
import { AppyUser } from '../../core/model/v2/AppyUser';
import { PatientAddress } from '../../core/models/patient/patientAddress';
declare var $: any;

@Component({
  selector: 'app-patient-profile',
  templateUrl: './patient-profile.component.html',
  styleUrls: ['./patient-profile.component.scss']
  //encapsulation: ViewEncapsulation.None
})
export class PatientProfileComponent implements OnInit, OnChanges, OnDestroy {

  @Input() patientDetails: Patient;
  @Input() editEnable: boolean;
  patientMedicationDetails: PatientMedication[];
  user: AppyUser;

  toggleSidebar = false;
  practitioner$: BehaviorSubject<Practitioner> = new BehaviorSubject(null);
  practitionerId = 0;
  photoUrlsend: string;
  selectedIndex = 0;
  selectedFile = null;
  sideBarHeader: string;
  patientProfile: Patient;

  @Output() toggleEditEvent = new EventEmitter();

  emergencyContact: PatientEmergencyContactInfo;
  childrenGuardian: PatientChildren;
  advancedDirective: PatientAdvancedDirective;
  pharmacyPreference: PharmacyDetails;
  patientInsurance: PatientInsuranceDetail;

  homeContact: PatientContactPreferences;
  mobileContact: PatientContactPreferences;
  workContact: PatientContactPreferences;
  emailContact: PatientContactPreferences;

  isParams = false;
  param: number;

  sectionName: string;
  default: boolean = false;
  private patientInfoDialog: MatDialogRef<TemplateRef<any>>;
  showEdit: boolean = false;
  addresses: PatientAddress[] = [];

  toggleEdit() {
    this.toggleEditEvent.emit();
  }
  @ViewChild(ProfileEmergencyContactInfoComponent, { static: false }) ProfileEmergencyContactInfo: ProfileEmergencyContactInfoComponent;

  @ViewChild(SidebarPatientEditComponent, { static: false }) childComponent: SidebarPatientEditComponent;
  @ViewChild('callAPIDialog', { static: false }) callAPIDialog: TemplateRef<any>;
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private router: ActivatedRoute,
    public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    private eventEmitterService: EventEmitterService,
    private changeDetectorRef: ChangeDetectorRef,
    //private profileEmergencyContactInfo: ProfileEmergencyContactInfoComponent
  ) { }

  ngOnInit() {
    $(document).ready(function () {
      $('.myTab-div li a').click(function (event) {
        $('.myTab-div li a.active').removeClass('active');
        $(this).addClass('active');
        var href = $(this).attr('href');
        $('#myTabContent .tab-pane').removeClass('show active');
        $(href).addClass('show active');

      });
    });
    if (this.editEnable == undefined) {
      this.editEnable = true;
    }

    this.router.params.subscribe(
      (params: any) => {
        if (params.id) {
          this.isParams = true;
          this.param = params.id;
        }
      },
      (error) => { console.error(error); }
    );

    this.getPatientDetails();

    if (this.eventEmitterService.subsVar == undefined) {
      this.eventEmitterService.subsVar = this.eventEmitterService.
        invokePatientProfileComponentFunction.subscribe(() => {
          this.triggerAddressClick();
        });
    }

  }

  ngOnChanges() {
    let p1 = 0;
  }
  ngOnDestroy(): void { }

  filterAddressType(type) {
    if (this.patientProfile) {
      return this.patientProfile.addresses.filter(x => x.type === type && x.active === true);
    }
    return;
  }
  getHomenumber() {
    return this.patientProfile.patientContactPreferences.filter(x => x.contactType === 'HOMENUMBER')[0].contactValue;
  }

  getPatientDetails() {
    this.userService.getUserDetails().subscribe(
      (res) => {
        this.user = res;
        if (this.isParams || this.patientDetails != null) {
          this.getPatientDetailsById(this.param ? this.param : this.patientDetails.id);
        } else {
          this.getPatientDetailsByUserId();
        }
      },
      (error) => { console.error(error); });
  }

  getPatientDetailsById(id) {
    //id = 35178;
    this.loaderService.blockWithLoader(this.patientService.getPatientDetailsById(id)).subscribe(
      (details) => {
        this.patientProfile = null;
        this.patientProfile = details;
        this.default = !this.patientProfile.photoUrl ? true : false;
        this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
        this.populateAddresses();
        this.setPreferredContact();
        this.changeDetectorRef.detectChanges();
      },
      (error) => { console.error(error); }
    );
  }

  getPatientDetailsByUserId() {
    this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
      (details) => {
        this.patientProfile = null;
        this.patientProfile = details;
        this.default = !this.patientProfile.photoUrl ? true : false;
        this.patientProfile.photoUrl = this.patientProfile.photoUrl += '?' + Math.random();
        this.populateAddresses();
        this.setPreferredContact();
        this.changeDetectorRef.detectChanges();
      },
      (error) => { console.error(error); }
    );
  }

  setPreferredContact() {
    this.homeContact = this.patientProfile && this.patientProfile.patientContactPreferences ? this.patientProfile.patientContactPreferences.find(pc => pc.contactType == 'HOMENUMBER') : null;
    this.mobileContact = this.patientProfile && this.patientProfile.patientContactPreferences ? this.patientProfile.patientContactPreferences.find(pc => pc.contactType == 'MOBILENUMBER') : null;
    this.workContact = this.patientProfile && this.patientProfile.patientContactPreferences ? this.patientProfile.patientContactPreferences.find(pc => pc.contactType == 'WORKNUMBER') : null;
    this.emailContact = this.patientProfile && this.patientProfile.patientContactPreferences ? this.patientProfile.patientContactPreferences.find(pc => pc.contactType == 'EMAIL') : null;

    if (!this.homeContact) {
      this.homeContact = new PatientContactPreferences;
      this.homeContact.active = true;
      this.homeContact.contactType = 'HOMENUMBER';
      this.homeContact.isCallAllowed = false;
      this.homeContact.isPreferred = false;
      this.homeContact.isTextAllowed = false;
      this.homeContact.patientId = this.patientProfile.id;
    }
    if (!this.mobileContact) {
      this.mobileContact = new PatientContactPreferences;
      this.mobileContact.active = true;
      this.mobileContact.contactType = 'MOBILENUMBER';
      this.mobileContact.isCallAllowed = false;
      this.mobileContact.isPreferred = false;
      this.mobileContact.isTextAllowed = false;
      this.mobileContact.patientId = this.patientProfile.id;
    }
    if (!this.workContact) {
      this.workContact = new PatientContactPreferences;
      this.workContact.active = true;
      this.workContact.contactType = 'WORKNUMBER';
      this.workContact.isCallAllowed = false;
      this.workContact.isPreferred = false;
      this.workContact.isTextAllowed = false;
      this.workContact.patientId = this.patientProfile.id;
    }
    if (!this.emailContact) {
      this.emailContact = new PatientContactPreferences;
      this.emailContact.active = true;
      this.emailContact.contactType = 'EMAIL';
      this.emailContact.isCallAllowed = false;
      this.emailContact.isPreferred = false;
      this.emailContact.isTextAllowed = false;
      this.emailContact.patientId = this.patientProfile.id;
    }
  }
  getAge(dob) {
    let age;
    const convertAge = new Date(dob);
    const timeDiff = Math.abs(Date.now() - convertAge.getTime());
    age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    return age;
  }
  openEditPhoto() {
    const pid = this.patientProfile.id;
    var preferredName = (this.patientProfile != null && this.patientProfile.preferredName) ? this.patientProfile.preferredName : this.patientProfile.firstName;
    var urlPhoto = this.patientProfile != null ? this.patientProfile.photoUrl : null;
    const dialogRef = this.dialog.open(PatientPhotoEditComponent, {
      width: '528px',
      disableClose: true,
      data: { pid: pid, preferredName: preferredName, urlPhoto: urlPhoto }
    });

    dialogRef.afterClosed().subscribe(
      (photoUrl: any) => {
        if (photoUrl && this.patientProfile != null) {
          this.patientProfile.photoUrl = photoUrl;
        }
      },
      (error) => { console.error(error); }
    );
  }
  public showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector('body');
    if (isOpen) {
      body.style.cssText = 'min-height:100vh; overflow:hidden';
    } else {
      body.style.cssText = 'min-height:auto; overflow:visible';
    }
  }
  public setSidebarHeader(sectionName: string) {
    switch (sectionName) {
      case "basicInfo":
        this.sideBarHeader = "Basic Information";
        break;
      case "contactInfo":
        this.sideBarHeader = "Personal Info";
        break;
      case "addressInfo":
        // this.sideBarHeader = "<i class='title-icon icon-address'></i> Edit Address";
        this.sideBarHeader = "Address Info";
        break;
      case "employmentInfo":
        this.sideBarHeader = "Employment Info";
        break;
      case "driverLicense":
        this.sideBarHeader = "Drivers License";
        break;
      case "emergencyContactInfo":
        this.sideBarHeader = "Add Emergency Contact Info";
        break;
      case "AddChildrenGuardianship":
        this.sideBarHeader = "Add Children or Legal Guardianship";
        break;
      case "EditChildrenGuardianship":
        this.sideBarHeader = "Edit Children or Legal Guardianship";
        break;
      case "AddAdvancedDirective":
        this.sideBarHeader = "Add Advanced Directives";
        break;
      case "EditAdvancedDirective":
        this.sideBarHeader = "Edit Advanced Directives";
        break;
      case "pharmacyPreferences":
        this.sideBarHeader = "Add Phamacy Preference";
        break;
      case "physicalCharacterInfo":
        this.sideBarHeader = "Physical Character";
        break;
      case "employerInfo":
        this.sideBarHeader = "Employer Info";
        break;
      case "militaryStatusInfo":
        this.sideBarHeader = "Military Status";
        break;
      case "EditPatientInsurance":
        this.sideBarHeader = "Edit Patient Insurance";
        break;
      case "AddPatientInsurance":
        this.sideBarHeader = "Add Patient Insurance";
        break;
      case "financialInfo":
        this.sideBarHeader = "Financial Information";
        break;
      case "medicationAllergy":
        this.sideBarHeader = "Medication & Allergy";
        break;
      case "medicalHistory":
        this.sideBarHeader = "Past Medical History";
        break;
      case "familyHistory":
        this.sideBarHeader = "Family History";
        break;
      default:
        this.sideBarHeader = "Demographics";
    }
  }
  toggleEditSidebar(sectionName: string) {
    this.setSidebarHeader(sectionName);
    this.sectionName = sectionName;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if (this.toggleSidebar === true) {
      this.patientInfoDialog = this.dialog.open(this.callAPIDialog, {
        panelClass: `${this.sectionName}-dialog--popup`,
        width: '1155px',
        disableClose: false,
      });
    }
  }
  showEditSection(sectionName: string) {
    this.setSidebarHeader(sectionName);
    this.sectionName = sectionName;
    this.toggleSidebar = !this.toggleSidebar;
    //this.showHideScroll(this.toggleSidebar);
    //this.destroyChild();
    if (this.toggleSidebar === true) {
      this.showEdit = true;
    }
  }

  AddNewEmergency() {
    const patientEmergencyContact = new PatientEmergencyContactInfo();
    patientEmergencyContact.patientId = this.patientProfile.id;
    this.ProfileEmergencyContactInfo.toggleRowEditEmergency(patientEmergencyContact);
  }

  closeDialogBox() {
    this.toggleSidebar = false;
    this.showHideScroll(this.toggleSidebar);
    this.patientInfoDialog.close();
  }
  toggleEditEmergency(emergencyContactInfo: PatientEmergencyContactInfo) {
    this.emergencyContact = emergencyContactInfo;
    this.setSidebarHeader("emergencyContactInfo");
    this.sectionName = "emergencyContactInfo";
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if (this.toggleSidebar === true) {
      this.patientInfoDialog = this.dialog.open(this.callAPIDialog, {
        panelClass: `${this.sectionName}-dialog--popup`,
        width: '1155px',
        disableClose: false,
      });
    }
  }

  toggleEditChildrenGuardian(children: PatientChildren) {
    this.childrenGuardian = children;
    this.setSidebarHeader(this.childrenGuardian.id ? "EditChildrenGuardianship" : "AddChildrenGuardianship");
    this.sectionName = "childrenGuardianship";
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if (this.toggleSidebar === true) {
      this.patientInfoDialog = this.dialog.open(this.callAPIDialog, {
        panelClass: `${this.sectionName}-dialog--popup`,
        width: '528px',
        disableClose: false,
      });
    }
  }
  toggleEditAdvancedDirective(advancedDirective: PatientAdvancedDirective) {
    this.advancedDirective = advancedDirective;
    this.setSidebarHeader(this.advancedDirective.id ? "EditAdvancedDirective" : "AddAdvancedDirective");
    this.sectionName = "advancedDirective";
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if (this.toggleSidebar === true) {
      this.patientInfoDialog = this.dialog.open(this.callAPIDialog, {
        panelClass: `${this.sectionName}-dialog--popup`,
        width: '528px',
        disableClose: false,
      });
    }
  }
  toggleEditPharmacyPreferences(pharmacyPreferences: PharmacyDetails) {
    this.pharmacyPreference = pharmacyPreferences;
    this.setSidebarHeader("pharmacyPreferences");
    this.sectionName = "pharmacyPreferences";
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if (this.toggleSidebar === true) {
      this.patientInfoDialog = this.dialog.open(this.callAPIDialog, {
        panelClass: `${this.sectionName}-dialog--popup`,
        width: '900px',
        disableClose: false,
      });
    }

  }
  toggleEditInsurance(patientInsurance: PatientInsuranceDetail) {
    this.patientInsurance = patientInsurance;
    this.setSidebarHeader(this.patientInsurance.id ? "EditPatientInsurance" : "AddPatientInsurance");
    this.sectionName = "patientInsurance";
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    if (this.toggleSidebar === true) {
      this.patientInfoDialog = this.dialog.open(this.callAPIDialog, {
        panelClass: `${this.sectionName}-dialog--popup`,
        width: '900px',
        disableClose: false,
      });
    }
  }

  togglePopUp(patientProfile: Patient) {
    //this.patientProfile = patientProfile;
    this.getPatientDetails();
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
    this.showEdit = false;
    if (this.toggleSidebar === false && this.patientInfoDialog) {
      this.patientInfoDialog.close();
    }
  }
  makeEditFalse() {
    this.showEdit = false;
  }
  triggerAddressClick() {
    if (document.getElementById('addressInfo-tab') != null) {
      let element: HTMLElement = document.getElementById('addressInfo-tab') as HTMLElement;
      element.click();
    }
  }

  destroyChild() {
    this.childComponent.ngOnDestroy();
  }

  populateAddresses() {
    this.addresses = this.patientProfile.addresses;
  }

  uploadFile(event) {
    const self = this;

    self.selectedFile = event.target.files[0];

    this.patientService.uploadPatientEditPicture(self.patientProfile.id.toString(), self.selectedFile).subscribe(
      (res) => {
        if (res.isSuccess) {
          self.getPatientDetailsById(self.patientProfile.id);
        }
      },
      (error) => { console.error(error); }
    );
  }

  downloadDrivingLicence() {
    if (this.patientProfile) {
      if (this.patientProfile.patientDrivingLicenseDetails && this.patientProfile.patientDrivingLicenseDetails.driversLicenseFrontPictureUrl != null) {
        const a = document.createElement('a');
        const ext = this.patientProfile.patientDrivingLicenseDetails.driversLicenseFrontPictureUrl.split('.').pop();
        a.setAttribute('target', '_blank');
        a.href = this.patientProfile.patientDrivingLicenseDetails.driversLicenseFrontPictureUrl;
        a.setAttribute('download', `front.${ext}`);
        a.click();
        a.remove();
      }
      if (this.patientProfile.patientDrivingLicenseDetails && this.patientProfile.patientDrivingLicenseDetails.driversLicenseBackPictureUrl != null) {
        const a = document.createElement('a');
        const ext = this.patientProfile.patientDrivingLicenseDetails.driversLicenseBackPictureUrl.split('.').pop();
        a.setAttribute('target', '_blank');
        a.href = this.patientProfile.patientDrivingLicenseDetails.driversLicenseBackPictureUrl;
        a.setAttribute('download', `back.${ext}`);
        a.click();
        a.remove();
      }
    }

  }
}
